
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Emit, Prop} from 'vue-property-decorator';

  @Component({})
  export default class ChallengeDialogAccept extends Vue {
    @Prop({required: true, default: false})
    open!: boolean;

    @Prop({required: true})
    challengeId!: number;

    @Emit()
    accepted() {
      return;
    }

    @Emit()
    declined() {
      return;
    }
  }

